module.exports = __webpack_public_path__ + "static/media/Lorry.e59659e2.svg";